import { Chance } from "chance"
import { DictionaryScheduleType } from "etl/types";

const chance = new Chance();

export const dictionaryScheduleTypeFactoryMock = (howMany: number): DictionaryScheduleType[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/dictionary_schedule_types/${index + 1}`,
		"@type": "DictionaryScheduleType",
		id: index + 1,
		libelle: chance.word(),
		status: chance.word(),
		new_label: chance.word(),
		new_status: chance.word(),
		new_action: chance.word(),
		new_duration: chance.integer().toString(),
		new_background_color: chance.integer().toString(),
	}));
